module.exports = __webpack_public_path__ + "static/media/learning-6.fba3b525.png";